module.exports = __webpack_public_path__ + "components/rewards/christy/static/logo-237f55f032aa8352affd669f363c519f.webp";